import { lazy } from 'react';

export const PremiumOfferingLazy = lazy(() => import('./PremiumOffering'));
